import React, { memo, useEffect, useCallback, useState} from 'react';
import {getTranspose} from './getTranspose.js';
import {connect} from 'react-redux';
import TrackThumbnail from "components/TrackThumbnail.js";

const Grid = memo(({transpose, track, onMouseMove, onReleaseGrid, onClickGrid, pressed, row, col, num, isPlaying}) => { 
    window.track = track;
    return (
        <div
          onMouseMove={onMouseMove}
          onMouseLeave={() => onReleaseGrid(track, row, col)}
          onMouseDown={() => onClickGrid(track, row, col)}
          onMouseUp={() => onReleaseGrid(track, row, col)}
          className={
              isPlaying ? "grid playing" : (pressed && pressed.col === col && pressed.row === row) ?
                  "grid pressed" : "grid"
          }>
        </div>);
});

const mapStateToProps = (state, props) => {
    if (!props.track) {
        return {};
    }
    let transpose = props.transpose;
    return {
        isPlaying: props.track.notesTriggered && props.track.notesTriggered[
            transpose] !== undefined
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Grid);
